// extracted by mini-css-extract-plugin
export default {"containerQuiz":"Quizstyle_containerQuiz__iA21Q"};